import React from "react";

export default function About() {
    return (<div style={{color:"#fff"}}>About</div>);
}